<template>
  <div class="card-body mt-4">
    <div class="table-responsive">
      <h4>Order Data Performance</h4>
      <table class="table">
        <thead class="table-light">
        <tr>
          <th>Period</th>
          <th class="text-center">Filter Items</th>
          <th>Gross Total</th>
          <th>Net Total</th>
          <th>Qty</th>
          <th>Orders</th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in tableData" :key="index">
        <tr>
          <td>{{item.period}}</td>
          <td>
            <table class="table" v-if="item.filtered_records.length > 0">
              <thead class="table-light">
                <tr>
                  <th>Item</th>
                  <th>Gross Total</th>
                  <th>Net Total</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody v-for="(record, key) in item.filtered_records" :key="key">
                <tr>
                  <td>{{record.filter_record}}</td>
                  <td>{{record.filter_gross_total | formatNumber}}</td>
                  <td>{{record.filter_net_total | formatNumber}}</td>
                  <td>{{record.filter_item_units | formatNumber}}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>Ksh {{item.period_gross_total | formatNumber}}</td>
          <td>Ksh {{item.period_net_total | formatNumber}}</td>
          <td> {{item.period_item_units | formatNumber}}</td>
          <td v-if="item.period_order_details">
            <span v-b-modal.orders-performance-table @click="setOrders(item.period_order_details)" class="text-primary text-decoration-underline">{{item.period_orders | formatNumber}}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderPerformanceTable",
  props: {
    tableData: {
      type: Array,
      default (){
        return {
          categories: [],
          data: []
        }
      }
    },
  },
  methods: {
    setOrders(orders){
      this.$emit('setOrders', orders)
    }
  }
}
</script>

<style scoped>

</style>
